/**
 * Video Section Mobile Repositioning
 * Handles repositioning video sections above tabs on mobile screens
 */
document.addEventListener('DOMContentLoaded', function () {
    let originalVideoParent = null;
    let originalVideoNextSibling = null;
    let originalVideoHeight = 0;
    let originalVideoWidth = 0;
    let videoRepositioned = false;

    function repositionVideoOnMobile() {
        const videoSection = document.querySelector('.section-video');
        const tabsContainer = document.querySelector('.product-detail__tab-container, .product-detail__accordion-container');

        if (!videoSection || !tabsContainer) return;

        if (window.innerWidth <= 767) {
            // Mobile: Move video above tabs
            if (!videoSection.hasAttribute('data-repositioned')) {
                // Store original dimensions
                originalVideoHeight = videoSection.offsetHeight;
                originalVideoWidth = videoSection.offsetWidth;
                
                // Create a placeholder with the same height to prevent layout shift
                const placeholder = document.createElement('div');
                placeholder.style.height = originalVideoHeight + 'px';
                placeholder.style.width = '100%';
                placeholder.style.display = 'block';
                placeholder.id = 'video-section-placeholder';
                
                // Store original position
                originalVideoParent = videoSection.parentNode;
                originalVideoNextSibling = videoSection.nextElementSibling;
                
                // Insert placeholder
                originalVideoParent.insertBefore(placeholder, originalVideoNextSibling);
                
                videoSection.style.visibility = 'hidden'; // Hide before moving
                videoSection.style.height = originalVideoHeight + 'px'; // Maintain height
                videoSection.style.width = originalVideoWidth + 'px'; // Maintain width

                // Insert video section before the tabs container
                tabsContainer.parentNode.insertBefore(videoSection, tabsContainer);
                videoSection.setAttribute('data-repositioned', 'true');

                // Add some visual spacing
                videoSection.style.marginBottom = '20px';
                
                // Remove placeholder after a short delay
                setTimeout(() => {
                    const placeholder = document.getElementById('video-section-placeholder');
                    if (placeholder) {
                        placeholder.parentNode.removeChild(placeholder);
                    }
                    videoSection.style.visibility = ''; // Restore visibility
                    videoSection.style.height = ''; // Allow natural height
                    videoSection.style.width = ''; // Allow natural width
                }, 100);
                
                videoRepositioned = true;
            }
        } else {
            // Desktop: Restore original position
            if (videoSection.hasAttribute('data-repositioned') && originalVideoParent) {
                // Create placeholder at current position
                const currentPlaceholder = document.createElement('div');
                currentPlaceholder.style.height = videoSection.offsetHeight + 'px';
                currentPlaceholder.style.width = '100%';
                currentPlaceholder.style.display = 'block';
                currentPlaceholder.id = 'video-section-current-placeholder';
                
                videoSection.style.visibility = 'hidden'; // Hide before moving
                
                // Insert placeholder at current position
                videoSection.parentNode.insertBefore(currentPlaceholder, videoSection);

                // Restore to original position
                if (originalVideoNextSibling) {
                    originalVideoParent.insertBefore(videoSection, originalVideoNextSibling);
                } else {
                    originalVideoParent.appendChild(videoSection);
                }

                videoSection.removeAttribute('data-repositioned');
                videoSection.style.marginBottom = '';
                
                // Remove placeholder after a short delay
                setTimeout(() => {
                    const currentPlaceholder = document.getElementById('video-section-current-placeholder');
                    if (currentPlaceholder) {
                        currentPlaceholder.parentNode.removeChild(currentPlaceholder);
                    }
                    videoSection.style.visibility = ''; // Restore visibility
                }, 100);

                // Clear stored references
                originalVideoParent = null;
                originalVideoNextSibling = null;
                videoRepositioned = false;
            }
        }
    }

    // Initial repositioning with a slight delay to ensure DOM is fully loaded
    setTimeout(repositionVideoOnMobile, 100);

    // Handle window resize events with debounce
    let resizeTimeout;
    window.addEventListener('resize', function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function () {
            repositionVideoOnMobile();
        }, 250);
    });

    // Handle dynamic content loading
    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                // Check if video section or tabs were added
                const hasVideoSection = Array.from(mutation.addedNodes).some(node =>
                    node.nodeType === 1 && (
                        node.classList?.contains('section-video') ||
                        node.querySelector?.('.section-video')
                    )
                );

                const hasTabsContainer = Array.from(mutation.addedNodes).some(node =>
                    node.nodeType === 1 && (
                        node.classList?.contains('product-detail__tab-container') ||
                        node.classList?.contains('product-detail__accordion-container') ||
                        node.querySelector?.('.product-detail__tab-container, .product-detail__accordion-container')
                    )
                );

                if (hasVideoSection || hasTabsContainer) {
                    setTimeout(repositionVideoOnMobile, 100);
                }
            }
        });
    });

    // Start observing the document for changes
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}); 